// removed by extract-text-webpack-plugin
module.exports = {"container":"_5dgpD","title":"_3LJ0t","mobile-only":"spbXb","mobile-button-container":"_39MaO","desktop-button-container":"RInHF","social-button-wrapper":"_2oyXL","button":"_166d9","social-button":"_2iqqI","button-facebook":"_3KS-I","button-twitter":"u6xYU","button-email":"_2qO_7","button-whatsapp":"_3ObkP","button-sms":"_1oeaj","button-no-padding":"_2xlA8","button-sms-block":"_29yHZ","button-messenger":"_3_Njq","whatsapp-styles":"_2fukZ","sms-styles":"_3tNOo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialShare/SocialShare.scss
// module id = ./src/components/SocialShare/SocialShare.scss
// module chunks = 5